module.exports = __webpack_public_path__ + "img/gift.b6dd04d8.png";